import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Scrollbar.scss';

Scrollbar.propTypes = {
    children: PropTypes.element.isRequired,
};

export default function Scrollbar({ children }) {
    const { className, ...rest } = children.props;

    return React.cloneElement(
        children,
        {
            className: cn(styles.root, className),
            ...rest,
        },
        rest.children
    );
}
